// Shared vanilla CSS for the smaller activity content pieces: ActivityBodyContent,
// PassageReferenceBlock, ActivityEmptyContent, ActivitySolutionContent,
// ActivityEvaluationRubricContent, ActivityPreviewByData. Prefix: am-.
// Aggregated into libraryStyles.
export const activityMiscStyles = `
  /* ActivityBodyContent */
  .am-body-list { display: flex; flex-direction: column; }

  /* Passage body — block flow so a floated figure's following siblings can wrap
     around it (a flex column won't). container-type makes the float gate
     width-aware via @container in mediaStyles. The compound selector beats the
     base flex rule above regardless of aggregation order. PASSAGE-only. */
  .am-body-list.am-body-list--passage {
    display: block;
    container-type: inline-size;
    container-name: pac;
  }
  .am-body-list--passage::after { content: ""; display: block; clear: both; }
  /* The TEXT wrapper is normally flex (which would refuse to wrap a float);
     make passage prose plain block flow so its line boxes wrap the figure. */
  .am-body-list--passage .med-text-wrap { display: block; }

  /* Open-ended body — same block flow as a passage, but the figure floats LEFT
     so the question prose wraps to its right (compact, so the answer area sits
     higher instead of the image+text stacking full-height). OPEN_ENDED-only. */
  .am-body-list.am-body-list--oe {
    display: block;
    container-type: inline-size;
    container-name: pac;
  }
  .am-body-list--oe::after { content: ""; display: block; clear: both; }
  .am-body-list--oe .med-text-wrap { display: block; }

  /* shared special-expression + equation + section title + spacing */
  .am-bold { font-weight: 700; }
  .am-underline { text-decoration: underline; }
  .am-eq { font-size: var(--fs-xl); }
  .am-section-title {
    font-size: var(--fs-xl);
    font-weight: 700;
    text-align: center;
    margin-bottom: 0.75rem;
  }
  .am-mb2 { margin-bottom: 0.5rem; }
  .am-mb3 { margin-bottom: 0.75rem; }
  .am-my2 { margin-top: 0.5rem; margin-bottom: 0.5rem; }

  /* PassageReferenceBlock */
  .am-cite-wrap {
    margin-top: 0.5rem;
    font-size: var(--fs-sm);
    color: var(--catchup-gray);
    font-style: italic;
  }
  .am-cite { font-style: italic; font-size: var(--fs-sm); color: var(--catchup-gray); }
  .am-cite-link { font-style: italic; font-size: var(--fs-sm); color: var(--catchup-gray); }
  .am-cite-link:hover { text-decoration: underline; }

  /* ActivityEmptyContent */
  .am-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-width: 2px;
    border-style: solid;
    border-color: var(--catchup-orange);
    border-radius: var(--rad-catchup-xlarge);
    padding: 0.5rem 1.25rem;
    margin-bottom: 0.5rem;
    background-color: var(--catchup-orange);
    color: var(--catchup-white);
  }
  .am-empty-text { font-size: var(--fs-lg); }

  /* ActivitySolutionContent */
  .am-sol-wrap { margin-left: 0.5rem; margin-right: 0.5rem; }
  .am-sol-box {
    padding: 1rem;
    border-color: var(--catchup-blue);
    border-width: 2px;
    border-style: solid;
    border-radius: var(--rad-catchup-xlarge);
  }
  .am-sol-item { margin-top: 0.75rem; margin-bottom: 0.75rem; font-size: var(--fs-xl); }

  /* ActivityEvaluationRubricContent */
  .am-rub-box {
    padding: 1rem;
    border-color: var(--catchup-gray-400);
    border-width: 2px;
    border-style: solid;
    border-radius: var(--rad-catchup-xlarge);
  }
  .am-rub-row {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    display: flex;
    flex-direction: row;
    gap: 0.75rem;
  }
  .am-rub-points { font-weight: 700; font-size: var(--fs-xl); white-space: nowrap; }
  /* Unscored criterion (0 points): the generator writes these as grader RULES that
     carry no points, so the row says "Puansız" and reads as quieter than a scored
     one instead of claiming a zero score. */
  .am-rub-points--unscored { color: var(--text-muted); font-weight: 600; }
  .am-rub-text { flex: 1 1 0%; font-size: var(--fs-xl); white-space: pre-wrap; }

  /* ActivityPreviewByData */
  .am-prev-label { font-weight: 600; font-size: var(--fs-lg); }
  .am-prev-main { display: flex; flex-direction: column; margin-bottom: 0.5rem; width: 100%; }
`;
